import React from 'react';
import ReactDOM from 'react-dom/client';
// Schriften + Icon-Font lokal ausgeliefert (statt Google Fonts), damit der Service Worker sie cacht und
// Icons/Schrift auch beim Offline-Kaltstart da sind. Nur latin-Subsets (deckt Deutsch inkl. „–" ab).
import 'material-symbols/rounded.css';
import '@fontsource/ibm-plex-sans/latin-300.css';
import '@fontsource/ibm-plex-sans/latin-400.css';
import '@fontsource/ibm-plex-sans/latin-500.css';
import '@fontsource/ibm-plex-sans/latin-600.css';
import '@fontsource/ibm-plex-mono/latin-400.css';
import '@fontsource/ibm-plex-mono/latin-500.css';
import '@fontsource/bebas-neue/latin-400.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { ContextMenuProvider } from './components/context/ContextMenuContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode><Router><ContextMenuProvider>
    <div className={"backgroundFixed"}></div>
    <App />
  </ContextMenuProvider></Router></React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ('serviceWorker' in navigator) {
  if (process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .catch(err => console.error('Service Worker registration failed:', err));
    });
  } else {
    // Dev-Server (Hot-Reload): ein Service Worker stört HMR und kann Reload-Schleifen auslösen
    // -> im Dev keinen registrieren und einen evtl. vorhandenen entfernen.
    navigator.serviceWorker.getRegistrations()
      .then(regs => regs.forEach(r => r.unregister()))
      .catch(() => {});
  }
}
